import { Card } from "antd";
import React, { useEffect, useState } from "react";
import Gauge5 from "./Gauge5";
import { useStoreUpdaterWithAPI } from "../../../Hooks/UseStoreUpdaterWithApi";
import { getAdjustedDate } from "../CommonFunctions";
import dayjs from "dayjs";
import { adjustTimeByFiveHoursThirtyMinutes } from "../../../Utils/DateConverstion";
import { APIConstants } from "../../../Common/APIConstants";

const FoudaryChart = ({ cardStyle, theme }) => {
  const { makeRequest } = useStoreUpdaterWithAPI();
  const correctDate = new Date(getAdjustedDate());
  const defaultToDate = dayjs(correctDate).add(5, "minute");
  const defaultFromDate = dayjs(correctDate).subtract(5, "minute")

  const [toDate, setToDate] = useState(defaultToDate);
  const [fromDate, setFromDate] = useState(defaultFromDate);
  const [loading, setLoading] = useState(true); // New loading state
  const [pieData1, setPieData1] = useState([]);
  const [pieData2, setPieData2] = useState([]);
  const getReposnse = async () => {
    // setLoading(true)
    const currentDate = new Date();

    // const { from, to } = calculateDateRangeFromDate(currentDate, 15, 15);

    const inputData = {
      // ConverterID: Number(lgConvId),
      // MeterIds: ids,
      FromDate: adjustTimeByFiveHoursThirtyMinutes(fromDate),
      ToDate: adjustTimeByFiveHoursThirtyMinutes(toDate),
    };
    console.log("getReposnse");
    console.log(inputData.ToDate, inputData.FromDate);

    try {
      const res = await makeRequest({
        type: APIConstants.GET,
        url: `${APIConstants.SMML_LIVE_POWER_STATISTICS}?FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}`,
      });
      console.log(res);
      function rearrangeResponse(data) {
        return data.map(entry => ({
          kwh: entry.kwh,
          pft: entry.pft,
          voltage: entry.voltage,
          iavg: entry.iavg,
          vthd: entry.vthd,
          ithd: entry.ithd,
          kvat:entry.kvat,
          meterName: entry.meterName,
          meterID: entry.meterID
        }));
      }
      console.log(rearrangeResponse(res));
      const data = rearrangeResponse(res)
      if (res && res.length > 0) {
        setPieData1(data[0]);
        setPieData2(data[1]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    getReposnse();
  }, []);
  console.log(theme)
  console.log(pieData1)
  return (
    <Card className={`${theme==='dark'?'bg-transparent':'text-black bg-[#F5FBFF] '} p-0 mb-3 w-[100%] overflow-hidden h-[380px] text-left`}  style={cardStyle}>
    <div className="flex  gap-3 pb-0 overflow-hidden">
      <div className="flex-col w-1/2  ">
      <p className={`${theme==='dark'?'text-black':'text-black'} text-center bg-blue-200 py-2 rounded-lg mb-0.5`}>
      Foundry – 1 (SC No.-99)
      </p>
      <div className="flex h-[300px] text-center">
        <Card
          title={
            <span className={`${theme==='dark'?'text-white':'text-black '} text-center` }>Foundry 1 Demand (kVA)</span>
          }
        className={`${theme==='dark'?'bg-transparent':'text-black bg-[#E0F2FE]'} w-2/3`}
          style={cardStyle}
        >
          {/* <ReactECharts option={gaugeOption} /> */}
          <Gauge5 value={pieData1?.kvat} theme={theme} upperRange={5000} lowerRange={0} breakRange={4500}  />
        </Card>
        <Card className="w-1/3   bg-blue-100" style={cardStyle}>
          {Object.entries(pieData1)
            .filter(
              ([key]) =>
                key !== "meterName" && key !== "meterID" && key !== "kvat"
            ) // Exclude meterName & meterID
            .map(([key, value], index) => (
              <div
                key={index}
                className=" py-1 flex justify-between items-center my-2.5 w-full"
              >
                <span className="w-1/3 text-left">
                  {key === "iavg"
                    ? "Current"
                    : key === "pft"
                      ? "PF"
                      : key === "vthd"
                        ? "V THD"
                        : key === "ithd"
                          ? "I THD"
                          : key === "voltage"
                            ? "Voltage"
                            : key === "kwh"
                              ? "kW"
                              : key}
                </span>
                <span className="w-1/3 text-center">:</span>
                <span className="w-1/3 text-right">{value}</span>
              </div>
            ))}
        </Card>
      </div>
      </div>
      <div className="flex-col w-1/2  ">
      <p className={`${theme==='dark'?'text-black':'text-black'} text-center bg-blue-200 py-2 rounded-lg mb-0.5`}>
      Foundry – 2 (SC No.-127)
      </p>
      <div className="flex h-[300px] text-center">
        <Card
           title={
            <span className={`${theme==='dark'?'text-white':'text-black'}  text-center` }>Foundry 2 Demand (kVA)</span>
          }
          className={`${theme==='dark'?'bg-transparent':'text-black bg-[#E0F2FE]'} w-2/3`}
          style={cardStyle}
        >
          {/* <ReactECharts option={gaugeOption} /> */}
          <Gauge5 value={pieData2?.kvat} theme={theme} upperRange={7000} lowerRange={0} breakRange={6300} />
        </Card>
        <Card className="w-1/3  bg-blue-100 `" style={cardStyle}>
          {Object.entries(pieData2)
            .filter(
              ([key]) =>
                key !== "meterName" && key !== "meterID" && key !== "kvat"
            ) // Exclude meterName & meterID
            .map(([key, value], index) => (
              <div
                key={index}
                className="flex justify-between items-center py-1 my-2.5"
              >
                <span className="w-1/3 text-left">
                  {key === "iavg"
                    ? "Current"
                    : key === "pft"
                      ? "PF"
                      : key === "vthd"
                        ? "V THD"
                        : key === "ithd"
                          ? "I THD"
                          : key === "voltage"
                            ? "Voltage"
                            : key === "kwh"
                              ? "kW"
                              : key}
                </span>
                <span className="w-1/3 text-center">:</span>
                <span className="w-1/3 text-right">{value}</span>
              </div>
            ))}
        </Card>
      </div>
      </div>
    
    </div>
    </Card>
  );
};

export default FoudaryChart;
